export const ADOPTABOBBLES_DEVIATIONS_STREAM_GROUP_ID = 'adoptabobbles';
export const ADOPTABOBBLES_DEVIATIONS_STREAM_ID = 'adoptabobbles_ids_stream';
export const ADOPTABOBBLES_PER_FETCH = 12;
